import React from "react";
import { Field } from "formik";
import {InputContainer} from "styles/components/AnimatedInput";

const NameInput = (props) => {

  return (
    <Field name={props?.name}>
      {({ field, meta, form }) => {
        return (
          <InputContainer>
            <div className="input-container">
              <input
                className={`${meta.touched && meta.error ? "error" : ""}`}
                name={field.name}
                // placeholder={props?.placeholder}
                type={props?.type}
                value={field.value || ""}
                maxLength={props?.maxLength}
                disabled={props?.disabled}               
                onKeyUp={(evt) => {
                  const setValue = evt.target.value.replace(/[^a-zA-Z\s]/g, '')
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(props?.name, firstLetterCap);
                  props?.onChangeHandler && props?.onChangeHandler(firstLetterCap,field.value)
                }}
                onChange={() => {       }}
                {...field}
              />
             <label className={field.value && 'filled'} htmlFor={props?.name}>
                {props?.placeholder}
              </label>
              {props?.inputType !=="password" && meta.touched && meta.error && !props?.disabled && (
                <>             
                <p name={props?.name + "Error"} className="error-message">               
                  {meta.error}
                </p>
                </>
            
              )}
            </div>
          </InputContainer>
        );
      }}
    </Field>
  );
};
export default NameInput;
